module.exports = __webpack_public_path__ + "assets/a-14-zhutingqi.214b7c9e.svg";